/* eslint-disable react/react-in-jsx-scope */
import { projectStatus } from "@/constants/constants";
import { cn } from "@/libs/utils";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import slugify from "slugify";

type CardProjectType = {
  id: number;
  title: string;
  picture?: string;
  amount?: string;
  type?: string;
  link: string;
  className?: string;
  status: number;
};
const CardProject: FC<CardProjectType> = ({
  id,
  title,
  picture,
  type,
  link,
  className,
  status,
}) => {
  const typesProject = [];
  const typeProject = typesProject?.find((t) => {
    const slug = slugify(t.name, {
      lower: true,
      remove: /[*+~.()'"!:@]/g,
    });

    return slug === type;
  });

  const { t } = useTranslation("submit", {
    keyPrefix: "project",
  });

  return (
    <>
      <div>
        <Link
          to={link}
          className={cn(
            "aspect-[250/200] h-[170px] rounded-[15px] overflow-hidden relative flex",
            className
          )}
        >
          <div className="absolute left-0 top-0 size-full bg-slate-700">
            {picture ? (
              <img
                src={import.meta.env.VITE_MEDIA_BASE + "/media/" + picture}
                alt={title}
                className="size-full object-cover"
              />
            ) : typeProject?.image ? (
              <img
                src={import.meta.env.VITE_MEDIA_BASE + typeProject?.image.uri}
                alt="image en attente"
                className="size-full object-cover"
              />
            ) : (
              <img
                src="/pexels-pixabay-235925.jpg"
                alt="image en attente"
                className="size-full object-cover"
              />
            )}
          </div>
          <Status status={status} />
          <img
            src="/folder.svg"
            alt="picto folder"
            className="absolute left-3 top-4 w-5"
          />
        </Link>
        <div className="flex flex-col justify-end pt-4">
          <h2
            title={title}
            className="line-clamp-2 text-base font-normal leading-5"
          >
            <Link to={link}>{title}</Link>
          </h2>
        </div>
      </div>
    </>
  );
};

const Status: FC<{ status: number }> = ({ status }) => {
  let statusText = "";
  let bg = "background";
  let text = "foreground";

  const { t } = useTranslation("submit", {
    keyPrefix: "project",
  });

  switch (status) {
    case projectStatus.NotStarted:
      statusText = t("Non commencé");
      bg = "background";
      text = "foreground";
      break;
    case projectStatus.InProgress:
      statusText = t("En cours");
      bg = "muted";
      text = "muted-foreground";
      break;
    case projectStatus.AwaitingValidation:
      statusText = t("En attente de validation");
      bg = "secondary";
      text = "secondary-foreground";
      break;
    case projectStatus.Validated:
      statusText = t("Validé");
      bg = "primary";
      text = "primary-foreground";
      break;
    case projectStatus.Rejected:
      statusText = t("Refusé");
      bg = "destructive";
      text = "white";
      break;
    default:
      break;
  }
  return (
    <>
      <div
        hidden
        className="bg-[#00973C] bg-[#2710D8] bg-[#CE3030] bg-[#FF9500]"
      ></div>
      <div
        className={`bg-${bg} text-${text} absolute bottom-3 left-3 z-10 rounded-full px-2 py-1 text-xs`}
      >
        {statusText}
      </div>
    </>
  );
};
export default CardProject;
